
import styled from "@emotion/styled";
import localeService from "../../../service/localeService.js";


export const CustomRegisterWrapper = styled.div(({ theme: { designTokens: DT }, isApplyCustomLayout, pathname }) => {

    if (!isApplyCustomLayout) return ``
    return `
        padding: 42px 32px;
        border-radius: 8px;
        border: 1px solid ${DT.T_COLOR_LINE_PRIMARY_LIGHT};
        background-color: ${DT.T_COLOR_BG_DEFAULT_BRIGHT};
        .social-title-left {
            position: relative;
            margin-bottom: 20px;
            &::after {
                content: '${localeService.getTranslate("CAMPUS25")}';
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                background-color: ${DT.T_COLOR_BG_DEFAULT_BRIGHT};

            }
        }
        .register-tc-wrapper {
            margin-top: 48px;
        }
    `;
});



// WEBPACK FOOTER //
// ./src/common/custom-layout/CustomRegisterWrapper/style.jsx